import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "button-wrap"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TagButton',
  props: {
    selected: {
      type: Boolean
    }
  },
  emits: ['click', 'update:selected'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const onClick = () => {
      const newValue = !props.selected;
      emits('update:selected', newValue);
      emits('click', newValue);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tag-button", {
          'tag-button__selected': props.selected
        }]),
        onClick: _cache[0] || (_cache[0] = $event => onClick())
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "default")])])], 2);
    };
  }
});